var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingMeta
        ? _c("Loading", { attrs: { text: "Lade Daten..." } })
        : [
            !_vm.meta.customerDataComplete
              ? [
                  _c("CompleteData", {
                    attrs: { customer: _vm.customer },
                    on: { complete: _vm.onCompleteData }
                  })
                ]
              : !_vm.meta.canContact && _vm.meta.voucher
              ? [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "7" } },
                        [
                          _c("PriceTable", {
                            attrs: {
                              "with-free": false,
                              "with-prices": false,
                              "only-product-id": _vm.meta.voucher.productId
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "5" } },
                        [
                          _c("JonInfo", {
                            staticClass: "mt-0",
                            attrs: {
                              "footer-image": "/img/customer_voucher.png"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "message",
                                fn: function() {
                                  return [
                                    _c("h3", [
                                      _vm._v(
                                        'Yeah, du hast einen Gutschein für "' +
                                          _vm._s(
                                            _vm.meta.voucher.productLabel
                                          ) +
                                          '"!'
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tDamit kannst du "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.meta.voucher.duration) +
                                            " Tage"
                                        )
                                      ]),
                                      _vm._v(" lang bis zu\n\t\t\t\t\t\t\t\t"),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.meta.voucher.contactingsPerMonth
                                          ) + " KandidatInnen"
                                        )
                                      ]),
                                      _vm._v(" kontaktieren.\n\t\t\t\t\t\t\t")
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "mt-3 mb-5" }, [
                                      _vm._v(
                                        '\n\t\t\t\t\t\t\t\tKlicke jetzt unten auf "Gutschein einlösen", um deine gratis Testphase zu beginnen!\n\t\t\t\t\t\t\t'
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("Button", {
                        attrs: {
                          text: "Gutschein einlösen",
                          icon: "checkmark",
                          loading: _vm.usingVoucher,
                          disabled: _vm.usingVoucher
                        },
                        on: { click: _vm.useVoucher }
                      })
                    ],
                    1
                  )
                ]
              : [
                  _c(
                    "FormGroup",
                    {
                      attrs: {
                        label: _vm.firstQuestionLabel,
                        "label-classes": ["font-weight-bold"]
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _vm.isTypeHire
                            ? _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\tDeine Zusage für eine Zusammenarbeit wird der Person sofort zugestellt.\n\t\t\t\t\t"
                                )
                              ])
                            : _c("JonInfo", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "message",
                                    fn: function() {
                                      return [
                                        _vm.isInitiatorCustomer
                                          ? _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "Möchtest du die Person kontaktieren?"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "Das passiert, wenn du "
                                                ),
                                                _c("b", [
                                                  _vm._v('"Jetzt kontaktieren"')
                                                ]),
                                                _vm._v(" klickst:")
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "ol",
                                                { staticClass: "pl-3 mt-3" },
                                                [
                                                  _c("li", [
                                                    _vm._v(
                                                      "Wir senden deine Kontaktanfrage an die Person."
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _vm._v(
                                                      '\n\t\t\t\t\t\t\t\t\t\tDie Person sieht dein anonymes Jobprofil und das "Matching"/die\n\t\t\t\t\t\t\t\t\t\tÜbereinstimmung.\n\t\t\t\t\t\t\t\t\t'
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\tNimmt die Person deine anonyme Kontaktanfrage an, dann erfährt sie den Namen\n\t\t\t\t\t\t\t\t\t\teurer Organisation und deinen Namen.\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\tDanach kann die Person entscheiden, ob sie an weiteren Schritten\n\t\t\t\t\t\t\t\t\t\tinteressiert ist und ihren eigenen Namen offenlegt und du erhältst eine\n\t\t\t\t\t\t\t\t\t\tentsprechende Nachricht.\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v("Viel Erfolg!")
                                              ])
                                            ])
                                          : _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\tMöchtest Du die Kontaktanfrage von der Person mit dem Profil\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.pseudonym.label
                                                      ) +
                                                      " annehmen?\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v(
                                                  "Das passiert, wenn du "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    '"Kontaktanfrage annehmen"'
                                                  )
                                                ]),
                                                _vm._v(" klickst:")
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "ol",
                                                { staticClass: "pl-3 mt-3" },
                                                [
                                                  _c("li", [
                                                    _vm._v(
                                                      "Die Person erfährt den Namen eurer Organisation und deinen Namen."
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _vm._v(
                                                      "Danach kann die Person entscheiden, ob sie an weiteren Schritten\n\t\t\t\t\t\t\t\t\t\tinteressiert ist und ihren eigenen Namen offenlegt und du erhältst eine\n\t\t\t\t\t\t\t\t\t\tentsprechende Nachricht.\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _vm._v("Viel Erfolg!")
                                              ])
                                            ])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "mt-3",
                              attrs: { disabled: !_vm.meta.canContact },
                              on: { change: _vm.emitChangeEvent },
                              model: {
                                value: _vm.shouldContact,
                                callback: function($$v) {
                                  _vm.shouldContact = $$v
                                },
                                expression: "shouldContact"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.confirmContactLabel) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.meta.canContact
                            ? _c(
                                "div",
                                { staticClass: "mt-1 error font-size-big" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\tDu hast kein aktives Abonnement oder die Anzahl der maximalen Kontaktierungen pro Monat\n\t\t\t\t\t\tbereits erreicht.\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.meta.customerDataComplete
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-grow-1" },
                            [
                              _c("Button", {
                                attrs: {
                                  text: _vm.isTypeAccept
                                    ? "Kontaktanfrage annehmen"
                                    : "Jetzt kontaktieren",
                                  icon: "checkmark",
                                  disabled: !_vm.dataValid || _vm.contacting,
                                  loading: _vm.contacting
                                },
                                on: { click: _vm.contact }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.meta.canContact
                            ? _c(
                                "div",
                                [
                                  _vm.purchasingSubscription
                                    ? _c("Button", {
                                        attrs: {
                                          text:
                                            "Ich habe ein Abonnement erworben",
                                          icon: "coins"
                                        },
                                        on: {
                                          click: _vm.onPurchasedSubscription
                                        }
                                      })
                                    : _c("Button", {
                                        attrs: {
                                          text: "Abonnement bearbeiten",
                                          icon: "coins"
                                        },
                                        on: { click: _vm.purchaseSubscription }
                                      })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }